import Quill, { Delta, Op } from 'quill/core';

function removeIdInArrayAttributeFromDelta(
  content: Delta,
  attribute: string,
  id: string,
): Delta {
  const change = new Delta();
  content.ops.forEach((op) => {
    const items = op.attributes?.[attribute];
    if (Array.isArray(items) && items.includes(id)) {
      const filtered = items.filter((item) => item !== id);
      change.retain(Op.length(op), {
        [attribute]: filtered.length ? filtered : null,
      });
      return;
    }

    if (op.insert && typeof op.insert === 'object') {
      if (op.insert['table-embed']) {
        const cellsChange: Record<string, { content: Op[] }> = {};
        // @ts-expect-error
        const cells = op.insert['table-embed'].cells || {};
        const identities = Object.keys(cells);
        identities.forEach((identity) => {
          const cellContent = cells[identity]?.content;
          if (cellContent) {
            const cellChange = removeIdInArrayAttributeFromDelta(
              new Delta(cellContent),
              attribute,
              id,
            );
            if (cellChange.length() > 0) {
              cellsChange[identity] = {
                content: cellChange.ops,
              };
            }
          }
        });

        if (Object.keys(cellsChange).length > 0) {
          change.retain({ 'table-embed': { cells: cellsChange } });
          return;
        }
      } else if (op.insert['code-embed']) {
        const codeChange = removeIdInArrayAttributeFromDelta(
          new Delta(op.insert['code-embed'] as Op[]),
          attribute,
          id,
        );
        if (codeChange.length() > 0) {
          change.retain({ 'code-embed': codeChange.ops });
          return;
        }
      }
    }

    change.retain(Op.length(op));
  });

  return change.chop();
}

export function contentContainsCommentThread(content: Delta, threadId: string) {
  const change = removeIdInArrayAttributeFromDelta(
    content,
    'comment',
    threadId,
  );
  return change.length() > 0;
}

export function contentContainsAnnotation(
  content: Delta,
  annotationId: string,
) {
  const change = removeIdInArrayAttributeFromDelta(
    content,
    'annotation',
    annotationId,
  );
  return change.length() > 0;
}

export function removeReactionThreadFromEditor(quill: Quill, threadId: string) {
  const range = quill.getSelection();
  const change = removeIdInArrayAttributeFromDelta(
    quill.getContents(),
    'reaction',
    threadId,
  );
  if (change.length() === 0) {
    return;
  }
  quill.editReadOnly(() => {
    // prevent undo from re-introducing reaction
    quill.history.cutoff();
    /* eslint-disable no-param-reassign */
    quill.history.ignoreChange = true;
    quill.updateContents(change, Quill.sources.USER);
    quill.history.ignoreChange = false;
    /* eslint-enable no-param-reassign */
  });
  if (range) {
    quill.root.focus({ preventScroll: true });
    quill.setSelection(range, Quill.sources.SILENT);
  }
}
